import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_w9dsuas', 'template_jdyw63q', e.target, 'NzaBc2YLye8JDL1q9')
            .then((result) => {
                console.log(result.text);
                toast.success("Mail Sent")
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div>
            <h1 className=" text-center text-4xl font-semibold text-blue-800 my-10">Contact Me</h1>

            <div className="flex justify-center items-center">
                <form className="form" ref={form} onSubmit={sendEmail}>

                    <div className="grid grid-cols-1 gap-2">

                        <label htmlFor="firstName">First name</label>
                        <input
                            type="text"
                            name="firstName"
                            className="w-96 p-2 border-2 rounded-md outline-none text-sm mb-4 mt-2"
                            tabIndex="1"
                        />
                        <label htmlFor="lastName">Last name</label>
                        <input
                            type="text"
                            name="lastName"
                            className="w-full p-2 border-2 rounded-md outline-none text-sm mb-4 mt-2"
                            tabIndex="2"
                        />
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            name="email"
                            className="w-full p-2 border-2 rounded-md outline-none text-sm mb-4 mt-2"
                            placeholder="example@mail.com"
                            tabIndex="3"
                        />
                        <label htmlFor="message">Message</label>

                        <textarea
                            placeholder="Type your message"
                            className="message"
                            name="message"
                        />
                        <input type="submit" value="Send Messages" className=" btn btn-primary btn-sm send mt-3 mb-8" />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Contact;